import PropTypes from 'prop-types'

import FolderOpen from 'Images/folders/folder-open.svg'
import { Box, Image, Heading } from '@redriverpress/system'

export default function EmptyState({ action, message }) {
  return (
    <Box py={5} px={3} textAlign='center' bg='white'>
      <Image
        src={FolderOpen}
        alt='Illustration of an open folder'
        role='presentation'
        mb={[3, null, 4]}
        mx='auto'
        width='230px'
        height='auto'
      />
      <Heading as='h4' mb={0}>
        {message}
      </Heading>
      {action && action}
    </Box>
  )
}

EmptyState.defaultProps = {
  action: null,
}

EmptyState.propTypes = {
  action: PropTypes.node,
  message: PropTypes.string.isRequired,
}
